<div class="choices-rating">
  <label
    [attr.for]="field().key"
    class="mb-0 d-block fw-bold widget-label"
    >{{ field().settings?.label }}
    @if (field().settings?.required) {
      <span class="text-primary ms-1">*</span>
    }
  </label>

  <div class="row mt-2">
    @if (items().length > 0) {
      @for (item of items(); track $index) {
        <div class="choices-rating-item d-flex align-items-center col col-4">
          <input
            [value]="item.score"
            class="radio-input me-1"
            [id]="item.label + '-' + field().key"
            [name]="field().key"
            type="radio"
            [class.disabled-input]="!editable"
            [checked]="+item.score === +formControl?.value"
            (change)="onChangeChoice($event)"
          />

          <div
            appTooltip
            class="d-flex align-items-center"
            [ngbTooltip]="item.label"
          >
            <label
              class="radio-info truncate-line-1"
              [for]="item.label + '-' + field().key"
              [class.disabled-action]="!editable"
            >
              <span class="radio-text font-size-base">
                {{ item.label }}
              </span>
            </label>
          </div>
        </div>
      }
    }
  </div>
</div>
